// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"74f85ea6","529":"df6db161","563":"80a515a8","661":"fffc3fec","840":"0fb3e648"}[chunkId] + ".chunk.js";
};